/** Team overlay fields that are not person catalog keys. */

export const TEAM_OVERLAY_FIELD_DAILY_RATE = "dailyRate";

export const TEAM_OVERLAY_ATTRIBUTES_ENABLED = true;

export const isTeamOverlayFieldKey = (key: string): boolean =>
  key === TEAM_OVERLAY_FIELD_DAILY_RATE || key.startsWith("team.");

export const withoutTeamOverlayQueryKeys = (
  keys: readonly string[]
): string[] => keys.filter((key) => key !== TEAM_OVERLAY_FIELD_DAILY_RATE);

export const getTeamOverlayQueryFlags = ({
  overlaysEnabled,
  isDirectoryUser,
}: {
  overlaysEnabled: boolean;
  isDirectoryUser: boolean;
}): { includeOverlayTeamDailyRate: boolean } => ({
  includeOverlayTeamDailyRate:
    TEAM_OVERLAY_ATTRIBUTES_ENABLED && overlaysEnabled && !isDirectoryUser,
});
